import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius4};

  ${props =>
    props.selected &&
    css`
      background-color: ${
        props.isNegative ? props.theme.colors.warning.surface : props.theme.colors.background.secondary
      };
    `}
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
`

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const ExpandButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: ${props => props.theme.colors.outline.default};
`

export const AmountContainer = styled.div`
  color: ${props => (props.hasError ? props.theme.colors.danger.default : 'inherit')};
`

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding-left: ${props => props.theme.spacing.sp16};
  margin-top: ${props => props.theme.spacing.sp16};
`

export const AmountRowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp16};
`

export const AmountInputContainer = styled.div`
  flex-shrink: 0;
  width: 40%;
`
